import './MainInfo.css'

export default function MainInfo() {
  return (
    <div className='MainInfo-main'>
      <div className='MainInfo-section'>
        <h3>
          LET US DO <br />
          YOUR LAUNDRY <br />
          TODAY
        </h3>
        <ul>
          <li>$1.99 per pound(Same day service)</li>
          <li>20 lbs or $40 minimum</li>
          <li>FREE pickup & delivery for all Vancouver area.</li>
        </ul>
      </div>
    </div>
  )
}
